/**
 * D-127 (Arthur, 29 October): where the Department queue page draws the deaths with no date recorded. The server
 * decides who may see them (shown: tiers 1-2 and a role in Legal, 163); the page decides only where: on the Legal tab,
 * or, for a reader who opens no Legal queue (the paralegal, who opens none, 147), on the page as it is. Never on another
 * department's tab, and never when there are none.
 */
export function showsLegalDeaths(
  answer: { shown: boolean; count: number } | undefined,
  department: string | null,
  openable: readonly string[],
): boolean {
  if (!answer?.shown || answer.count === 0) return false;
  return department === 'Legal' || !openable.includes('Legal');
}
